export const defaultEmailUpdateFrequency = "monthly";
export const defaultEmailUpdateTime = ["1"];
